import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useAuth } from '@/hooks/useAuth';
import { User, Mail, Shield } from 'lucide-react';

const ProfilePage = () => {
  const { user } = useAuth();

  return (
    <div className="max-w-2xl mx-auto space-y-8">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-4xl font-bold tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-500"
      >
        Profile Settings
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        <Card className="bg-slate-800/70 border-slate-700 shadow-xl">
          <CardHeader>
            <CardTitle className="text-2xl text-slate-200">Account Information</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="bg-slate-700/50 p-4 rounded-lg space-y-4">
              <div className="flex items-center text-slate-300">
                <User className="h-5 w-5 mr-3 text-blue-400" />
                <span className="font-medium mr-2">Name:</span>
                <span className="text-slate-400">{user?.name || 'Not set'}</span>
              </div>
              <div className="flex items-center text-slate-300">
                <Mail className="h-5 w-5 mr-3 text-green-400" />
                <span className="font-medium mr-2">Email:</span>
                <span className="text-slate-400">{user?.email}</span>
              </div>
              <div className="flex items-center text-slate-300">
                <Shield className="h-5 w-5 mr-3 text-purple-400" />
                <span className="font-medium mr-2">Role:</span>
                <span className="text-slate-400">{user?.role || 'Standard User'}</span>
              </div>
            </div>
          </CardContent>
        </Card>
      </motion.div>
    </div>
  );
};

export default ProfilePage;